import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Button, Input, Comment, Select, DatePicker, Tabs } from "antd";
import "./ManageSpends.css";
import { SearchOutlined } from "@ant-design/icons";
import ManageSpendsCard from "../components/MsCard";
import { getAllPayments } from "../../../redux/actions";
// import Loader from "../Loading/Loader";
import Loader from "../../../components/Loading/Loader";
import moment from "moment";

export default function ManageSpends() {
  const { TabPane } = Tabs;
  const dispatch = useDispatch();
  const { Option } = Select;
  const { RangePicker } = DatePicker;

  const payments = useSelector((state) => state.getAllPaymentsReducer.payments);

  const [isSpend, setisSpend] = useState("Pending");
  const [type, settype] = useState("tilldate");
  const [startDate, setstartDate] = useState(null);
  const [endDate, setendDate] = useState(null);
  const [switchtab, setswitchtab] = useState(true)
  const [totalPaid, settotalPaid]=useState(0);
 


  useEffect(() => {
    dispatch(
      getAllPayments(
        type,
        startDate,
        endDate
      )
    );
  }, [type, startDate, switchtab]);


  const handleChange = (value,dateString) => {
    settype(value)
    settotalPaid(0)

    if (type=="custom"){
      setstartDate(moment(dateString[0]).format('MMMM DD, YYYY')+"T00:00:00.000Z")
      setendDate(moment(dateString[1]).format('MMMM DD, YYYY')+"T00:00:00.000Z")
    }

  };

  const onChange = (value, dateString) => {
    setstartDate(moment(dateString[0]).format('MMMM DD, YYYY')+"T00:00:00.000Z")
    setendDate(moment(dateString[1]).format('MMMM DD, YYYY')+"T00:00:00.000Z")
  };

  return (

    payments.length ===0?(
          <Loader/>
    )
  :
  (

    <div className="manageSpends">
      <div
        style={{
          marginTop: "7rem",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {/* <Col xs={22} sm={22} lg={12} xl={12}> */}
        <div className="msspend-head paddingLR">Manage spends</div>

        <div className="tabs-manageSpends">
        <Tabs
          className="top_tabs_jobs"
          defaultActiveKey="Pending"
          // onChange={callback}
          tabBarGutter={90}
          tabBarStyle={{ marginLeft: "2%", marginRight: "2%" }}
        >
          <TabPane tab={<div className="tab-title" 
                 onClick={()=>{
                  setswitchtab(true)
                  setisSpend ("Pending")
                }}
          >To be paid (${payments?.totalPaidAmount})</div>} key="Pending"></TabPane>
          <TabPane tab={<div className="tab-title" 
              onClick={()=>{
                setswitchtab(false)
                setisSpend ("Paid")
              }}
          >Spent (${payments?.totalSpentAmount})</div>} key="Paid"></TabPane>
          </Tabs>
        </div>

        <Row className="msspendHeader">
          <div
            className={`msspendCont msspend-title ${
              isSpend === "Pending" ? "msspend-title-Active" : ""
            }`}
     
          >
            To be paid ($({0}))
          </div>
          <div
            className={`msspend-messagesCont msspend-title ${
              isSpend === "Paid" ? "msspend-title-Active" : ""
            }`}
        
          >
            Spent ($1500)
          </div>
        </Row>

        <Row className="paddingLR filtersContainer">
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={10}
            xl={10}
            // style={{ marginTop: "9px" }}
          >
            <Row className="searchContainer">
              <Col xs={24} sm={24} md={24} lg={18} xl={18}>
              <Input
                className="msspend-inp"
                type="input"
                placeholder="Find candidates or skill listings"
                prefix={<SearchOutlined className="msspend-searchicon" />}
                //   onChange={(e) => searchHandler(e.target.value)}
              />
              </Col>
              <Col lg={6} xl={6} 
              >
              <Button className="searchBtn">Search</Button>
              </Col>
            </Row>
          </Col>
          <Col 
          xs={24}
          sm={24}
          md={24}
          lg={8}
          xl={8}

          // style={{background:'pink'}}
          >
            <Row className="DateContainer">
              <Col xs={7} xm={7} md={7} lg={6} xl={6}>
                <Select
                className="dateFilter"
                  defaultValue="tilldate"
                  style={{ width: "100%" }}
                  onChange={handleChange}
                >
                  <Option value="tilldate">Till date</Option>
                  <Option value="thisweek" onChange={
                     
                    ()=>settype("thisweek")
                    
                  }
                  >This week</Option>
                 
                  <Option value="thismonth" onChange={()=>settype("thismonth")}>This Month</Option>
                  <Option value="custom">Custom</Option>
                </Select>
              </Col>
              
              <Col xs={15} sm={15} md={15} lg={16} xl={16}>
                <RangePicker onChange={onChange}/>
              </Col>
            </Row>
          </Col>
        </Row>
        </div>
        <div className="paymentCardsList-cont">
        
{
  switchtab?
  
  <Row className="paymentCardsList">
        

          {payments?.toBePaid?.map((item, index) => {
            // console.log("itemmm is", item)
            return (
              
              <Col span={24} key={index}>
                <div  style={{marginBottom: "15px"}}>
                <ManageSpendsCard item={item} isSpend={isSpend} totalPaid={totalPaid} settotalPaid={settotalPaid}/>
                {/* <div>abbbbbbbbbc</div> */}
                </div>
              </Col>
            );
          })}
        </Row>
  :

  <Row className="paymentCardsList">
  {payments?.spent?.map((item, index) => {
    
    return (
      
      <Col span={24} key={index}>
        <div style={{marginBottom: "15px"}}>
        <ManageSpendsCard item={item} isSpend={isSpend} />
        {/* <div>abbbbbbbbbc</div> */}
        </div>
      </Col>
    );
  })}
</Row>

}
</div>
        
<div className="manageSpends">
        {isSpend === "Pending" ? (
          <div className="paddingLR btnContainerSpends">
            <Button className="msspend-btn">Proceed to pay $({totalPaid})</Button>
          </div>
        ) : null}

        {/* </Col> */}
      </div>
      </div>
    )
  
  );
}
